import axiosConfig from "./axiosConfig";

interface HhDataTempConfig {
  config: any | null;
}

const getHhDataTempConfig = async (
  authToken: string,
  fileGuid: string
): Promise<HhDataTempConfig> => {
  const { data } = await axiosConfig.get(`/hh_data/temp/${fileGuid}/config`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getHhDataTempConfig;
